import React from 'react';
import { useParams, Link } from 'react-router-dom';
import '../styles/ServiceDetail.css';

const serviceDetails = {
  astrology: {
    title: 'Astrology Consultancy',
    description: 'Get personalized predictions and guidance from certified astrologers.',
    image: '/images/astrology.jpg',
  },
  law: {
    title: 'Law Consultancy',
    description: 'Professional legal advice and support for all your needs.',
    image: '/images/law.webp',
  },
  'cs-projects': {
    title: 'CS Projects (UG/PG/PHD)',
    description: 'Guidance and development for academic and research projects.',
    image: '/images/cs-projects.jpg',
  },
  homeopathy: {
    title: 'Homeopathy Consultancy',
    description: 'Consult certified doctors for holistic healing solutions.',
    image: '/images/homeopathy.jpg',
  },
  civil: {
    title: 'Civil Works Consultancy',
    description: 'Expert insights into construction and structural engineering.',
    image: '/images/civil.jpg',
  },
  research: {
    title: 'Research Consultancy',
    description: 'Expert help with thesis, publications, and research mentoring (UG/PG/PHD).',
    image: '/images/research-bg.jpg',
  },
};

const ServiceDetail = () => {
  const { serviceId } = useParams();
  const service = serviceDetails[serviceId];

  if (!service) return <p>Service not found</p>;

  return (
    <div
      className="service-detail-container"
      style={{
        backgroundImage: `url(${service.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        position: 'relative',
        color: 'white',
      }}
    >
      <div className="overlay" />

      {/* Employee Login Button - Top Right */}
      <div className="top-right-buttons">
        <Link to={`/login/${serviceId}`} className="employee-login-top-right">
          Login
        </Link>

        {serviceId === 'research' && (
          <Link to="/research-course-details" className="course-details-button-top-right">
            Course Details
          </Link>

        )}
      </div>


      <div className="service-detail-content animated-fade-slide">
        <div className="card">
          <h1>{service.title}</h1>
          <p>{service.description}</p>

          {/* Center Book Appointment */}
          <div className="center-button">
            <Link to={`/appointment/${serviceId}`} className="appointment-button large-appointment">
              Book Appointment
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetail;
